import { namespace } from 'vuex-class'

export const PuntiluceMappaStore = namespace('puntiluceMappa')
export default {
    namespaced: true,
    state: {
        mostraConfiniComunali: false,
        mostraMappaSatellitare: false,
    },
    mutations: {
        SET_MOSTRA_CONFINI_COMUNALI: (state: any, value: boolean) => (state.mostraConfiniComunali = value),
        SET_MOSTRA_MAPPA_SATELLITARE: (state: any, value: boolean) => (state.mostraMappaSatellitare = value),
    }
}
